import type { ClientResource } from '@/features/Clients';

export const clientDevMock: ClientResource = {
  kundennummer: '0123456789',
  firma: '',
  anzahlKinder: 0,
  hoechsterBildungsabschluss: '7',
  groesse: 185,
  gewicht: 85,
  personalverantwortung: 0,
  fax: '04046092299',
  mobil: '0123456789',
  telefon: '04046093299',
  email: 'testmail@demv.de',
  nichtraucher: 'min10Jahre',
  berufsgruppe: '2',
  beruf: 'Softwareentwickler',
  geburtsland: 'DE',
  geburtsort: 'Hamburg',
  geburtsname: 'MustermannBirth',
  nationalitaet: 'DE',
  geburtsdatum: new Date('1984-05-10T00:00:00.000Z'),
  geschlecht: 'maennlich',
  nachname: 'Mustermann',
  vorname: 'Max',
  titel: '',
  familienstand: '6',
  bankverbindung: {
    bankname: 'DEUTSCHE KREDITBANK BERLIN',
    bic: 'BYLADEM1001',
    iban: 'DE02120300000000202051',
  },
  adresse: {
    ort: 'Hamburg',
    plz: '20354',
    hausnummer: '7a',
    strasse: 'Dammtorwall',
  },
  anteilTaetigkeitBuero: 90,
  anredeId: 1,
  id: 1,
  fuehrerscheindatum: new Date('2015-05-10T00:00:00.000Z'),
};
